import React from "react";
import { ReactComponent as RefundIcon } from '../assets/icons/refund.svg';
import "./app-modal-merchant.scss";
import { StatusType } from "../types/statistics.types";
import { getColorByStatusType } from "../utils/constants";

interface AppModalMerchantProps {
  text: string;
  id: string;
  merchantName: string;
  confirmLabel: string;
  cancelLabel: string;
  confirmAction: (id: string, status: StatusType) => Promise<void>;
  cancelAction: () => void;
  isVisible: boolean;
  status: StatusType;
}

const AppModalMerchant: React.FC<AppModalMerchantProps> = ({
  text,
  id,
  merchantName,
  confirmLabel,
  cancelLabel,
  confirmAction,
  cancelAction,
  isVisible,
  status
}) => {
  if (!isVisible) return null;

  const statusColor = getColorByStatusType(status);

  return (
    <div className="app-modal-merchant-overlay">
      <div className="app-modal">
        <div className="modal-icon">
          <RefundIcon color={statusColor} />
        </div>
        <div className="modal-content">
          <p className="modal-text">
            {text}
            <span style={{ color: statusColor }}>{merchantName}</span>?
          </p>
          <p className="modal-id">Merchant Id: {id}</p>
        </div>
        <div className="modal-actions">
          <button
            className="btn btn-cancel"
            onClick={cancelAction}>
            {cancelLabel}
          </button>
          <button
            className="btn btn-confirm"
            onClick={() => confirmAction(id, status)}
            style={{ backgroundColor: statusColor }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppModalMerchant;
